import React from "react";
import { Method } from "../../../../types";
import { UndersoegelsensMetodeMap } from "./undersoegelsens-metode";

interface LinkProps {
  link: string;
  children: string;
}

export function Link({ link, children }: LinkProps) {
  return (
    <a href={link} target="_blank" rel="noreferrer" className="link">
      {children}
    </a>
  );
}

function VidenskabeligPublicering() {
  return (
    <>
      Evidensbarometeret vægter kvalitetsstemplet forskning og straffer det
      modsatte.
      <br />
      <br />
      Derfor er det afgørende for barometerpilens udfald, om et studie er
      udgivet i et videnskabeligt tidsskrift og peer reviewed – det vil sige
      blåstemplet af uvildige fagfæller.
      <br />
      <br />
      En række andre eksempler vil derimod få Evidensbarometerets pil til at
      lande på rød.
      <br />
      <br />
      Det kan være rapporter fra{" "}
      <Link link="https://videnskab.dk/kultur-samfund/saadan-undgaar-du-at-blive-snydt-af-rapporter-fra-ministerier/">
        ministerier
      </Link>
      ,{" "}
      <Link link="https://videnskab.dk/kultur-samfund/den-frie-presse-influencers-og-kommunikationsfolk-hvad-er-forskellen/">
        interesseorganisationer
      </Link>{" "}
      eller endda{" "}
      <Link link="https://videnskab.dk/kultur-samfund/oksekoedsrapport-aarhus-universitet-har-gjort-det-foer-men-det-har-andre-ogsaa/">
        universiteter
      </Link>
      , hvis der ikke er tale om peer reviewed forskning.
      <br />
      <br />
      <Link link="https://videnskab.dk/krop-sundhed/ninka-sagen-kan-sund-kost-slukke-autisme-gener/">
        Anekdotebårne historier
      </Link>
      , blogs eller{" "}
      <Link link="https://videnskab.dk/krop-sundhed/spot-fup-paa-facebook-med-enkelte-greb/">
        meldinger fra selvudnævnte eksperter
      </Link>
      vil også få bundkarakter.
    </>
  );
}
interface UMProps {
  method: Method | undefined | null;
}

function UndersoegelsensMetode({ method }: UMProps) {
  if (method)
    return (
      <>
        <UndersoegelsensMetodeMap method={method} />
        <br />
        <br />
        Mere:
        <br />
        <br />
        <Link link="https://videnskab.dk/kultur-samfund/ikke-al-forskning-giver-lige-meget-evidens-laer-at-skelne/">
          Ikke al forskning giver lige meget evidens: Lær at skelne
        </Link>
        <br />
        <br />
        <Link link="https://videnskab.dk/krop-sundhed/hvad-er-videnskabelig-evidens/">
          Hvad er videnskabelig evidens?
        </Link>
        <br />
        <br />
        <Link link="https://www.youtube.com/watch?v=5T_vK0mLQ14/">
          5 spørgsmål, du bør stille dig selv, når du læser om forskning (video
          på YouTube)
        </Link>
      </>
    );
  return null;
}

function SamletEvidens() {
  return (
    <>
      Nye videnskabelige studier skal ses i forhold til de tidligere. Ét enkelt
      forskningsresultat kan ikke vælte årtiers forskning og viden – evidens –
      af pinden.
      <br />
      <br />
      Hvis studiet viser noget radikalt anderledes end anden forskning, skal du
      være på mærkerne. Er studiet meget bedre lavet end andre? Eller strider
      konklusionen mod hidtidig evidens uden synderlig god grund?
      <br />
      <br />
      Mange forskellige typer studier, der peger i samme retning, eller et
      særligt solidt studie, giver som udgangspunkt stærk evidens. I modsat fald
      er evidensen svagere.
      <br />
      <br />
      Læs mere i Videnskab.dk’s manifest:{" "}
      <Link link="https://videnskab.dk/kultur-samfund/manifest-tjek-altid-hvad-den-oevrige-forskning-viser/">
        Tjek altid, hvad den øvrige forskning viser
      </Link>
      .
    </>
  );
}

interface SBProps {
  customComment: string | undefined | null;
}

function SærligeBemærkninger({ customComment }: SBProps) {
  if (customComment) {
    return <>{customComment}</>;
  }
  return (
    <>
      Her kan du{" "}
      <Link link="https://videnskab.dk/serie/guide-til-videnskabsjournalistik/">se den tjekliste</Link>,
      Videnskab.dk’s journalister bruger til at undersøge studier om sundhed.
    </>
  );
}

export const Page = {
  VidenskabeligPublicering,
  SærligeBemærkninger,
  SamletEvidens,
  UndersoegelsensMetode,
};
